import { ArrowRight, CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Container } from "@/components/ui/container";
import { ReadinessCard } from "@/components/illustrations/readiness-card";
import { signupUrl } from "@/lib/content";

const reassurances = [
  "Free plan: 5 records per feature",
  "1 privacy document/month on Free",
  "PH DPA + GDPR launch packs",
  "Guidance, not legal advice",
];

export function Hero() {
  return (
    <section id="top" aria-labelledby="hero-heading" className="overflow-hidden">
      <Container className="grid gap-12 py-14 sm:py-20 lg:grid-cols-2 lg:items-center lg:py-28">
        <div>
          <p className="mb-4 text-sm font-semibold uppercase tracking-[0.16em] text-primary">
            Jurisdiction-aware privacy operations for small businesses
          </p>
          <h1
            id="hero-heading"
            className="text-4xl font-extrabold tracking-tight text-foreground sm:text-5xl lg:text-[3.25rem] lg:leading-[1.08]"
          >
            Make Data Protection Work.
          </h1>
          <p className="mt-6 max-w-xl text-lg leading-relaxed text-muted-foreground">
            Tell us where your business operates and how you handle personal information.
            DataProtection.work is being built to recommend the relevant privacy modules, turn
            requirements into guided work, and help you keep the records and evidence that show
            what you have done.
          </p>
          <p className="mt-4 max-w-xl text-sm leading-relaxed text-muted-foreground">
            Launch scope includes Philippines / PH DPA and GDPR / EU. Module activation is
            guidance based on your answers, not a binding legal determination.
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <Button size="lg" asChild>
              <a href={signupUrl}>
                Start Free
                <ArrowRight className="h-4 w-4" aria-hidden="true" />
              </a>
            </Button>
            <Button size="lg" variant="outline" asChild>
              <a href="#how-it-works">See How It Works</a>
            </Button>
          </div>

          <ul className="mt-6 grid gap-2 sm:grid-cols-2">
            {reassurances.map((item) => (
              <li
                key={item}
                className="flex min-w-0 items-start gap-1.5 text-sm font-medium text-muted-foreground"
              >
                <CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0 text-success" aria-hidden="true" />
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="mx-auto w-full min-w-0 max-w-md lg:mx-0 lg:max-w-none">
          <ReadinessCard compact />
        </div>
      </Container>
    </section>
  );
}
